import { render, staticRenderFns } from "./Setting2FA.vue?vue&type=template&id=bd871f08&scoped=true&"
import script from "./Setting2FA.vue?vue&type=script&lang=js&"
export * from "./Setting2FA.vue?vue&type=script&lang=js&"
import style0 from "./Setting2FA.vue?vue&type=style&index=0&id=bd871f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd871f08",
  null
  
)

export default component.exports